import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';
import { AuthGuard } from '../../components/AuthGuard';
import PickupLayout from './layouts/PickupLayout';
import ProgressPage from './progress/ProgressPage';
import PopAppointmentDetailPage from './progress/PopAppointmentDetailPage';
import AppointmentPage from './appointment/PickupAppointmentsPage';
import PickupTaskPage from './pickup-task/PickupTaskPage';
import AccountPage from './account/AccountPage';
import VehiclePage from './vehicle/VehiclePage';
import PickupSitePage from "./cooperation-warehouse/PickupSitePage";
import MapRoutingPage from './map/MapRoutingPage';
import CentralParcelsPage from "./parcels/CentralParcelsPage";
import CentralReportFilePage from "./download/CentralReportFilePage";
import PickupDriverTrackingPage from './driver-tracking/PickupDriverTrackingPage';

const PickupRoutes: React.FC = () => {
    return (
        <Routes>
            <Route path="/" element={<AuthGuard><PickupLayout /></AuthGuard>}>
                <Route path="progress" element={<ProgressPage />} />
                <Route path="pop-appointment/:id" element={<PopAppointmentDetailPage />} />
                <Route path="appointment" element={<AppointmentPage />} />
                <Route path="pickup-task" element={<PickupTaskPage />} />
                <Route path="account" element={<AccountPage />} />
                <Route path="vehicle" element={<VehiclePage />} />
                <Route path="rally-points" element={<Navigate to="/pickup/pickup-task" replace />} />
                {/* 审核池已并入「揽收站点」页内页签，旧路径重定向避免书签 404 */}
                <Route path="address-review-pool" element={<Navigate to="/pickup/cooperation-warehouse" replace />} />
                <Route path="cooperation-warehouse" element={<PickupSitePage />} />
                <Route path="map" element={<MapRoutingPage />} />
                <Route path="parcels" element={<CentralParcelsPage />} />
                <Route path="driver-tracking" element={<PickupDriverTrackingPage />} />
                <Route path="download" element={<CentralReportFilePage />} />
            </Route>
        </Routes>
    );
};

export default PickupRoutes; 
